import InfoPage from '../parts/SandBox/InfoPage';
import PageBoilerplate from '../templates/PageBoilerplate';

export default function SandboxInfoPage() {
  return <PageBoilerplate name="Sandbox" left={true}>
    <InfoPage />
  </PageBoilerplate>
}